import type { Card } from '../../types';

/** Salve (HEX-89): the common HP-economy support card. 1×1, single-die cost,
 * restores +4 HP to the player (default `heal` target is self). Counter-pressure
 * to combat attrition alongside post-victory regen + the doubled town heal. */
export const SALVE: Card = {
  id: 'salve',
  name: 'Salve',
  type: 'support',
  rarity: 'common',
  size: { w: 1, h: 1 },
  cost: [{ kind: 'min', value: 1 }],
  effects: [{ kind: 'heal', amount: 4 }],
};
